{
	"development": "UA-32552871-1",
	"demo": "UA-5889778-36",
	"staging": "UA-5889778-35",
	"production": "UA-5889778-1"
}
